// https://dadata.ru/api/suggest/name/

export enum GENDER_TYPES {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNKNOWN = 'UNKNOWN',
}

export const GENDER_TRANSLATION: { [key in GENDER_TYPES]: string } = {
  [GENDER_TYPES.MALE]: 'Мужской',
  [GENDER_TYPES.FEMALE]: 'Женский',
  [GENDER_TYPES.UNKNOWN]: 'Не определён',
};

export const GENDER_OPTIONS: GENDER_TYPES[] = [
  GENDER_TYPES.MALE,
  GENDER_TYPES.FEMALE,
  // GENDER_TYPES.UNKNOWN
];

export interface IFIORequest {
  query: string;
  count?: number;
  gender?: GENDER_TYPES;
  parts?: FIO_PARTS[];
}

// Объект, который возвращается из дадаты
export interface IFIOObject {
  surname: string;
  name: string;
  patronymic: string;
  gender: GENDER_TYPES;
  source: string;
  qc: QC_TYPES;
}

export interface IDadataFIO {
  value: string;
  unrestricted_value: string;
  data: IFIOObject;
}

export interface IPeopleSuggestions {
  suggestions: IDadataFIO[];
}

export interface IFIOInfo {
  firstName: string;
  middleName: string;
  lastName: string;
  dadataFio: IExternalDadataFIO;
}

// Дадата отдает снейк-кейс unrestrictedValue
// На фронте нужен camelCase
export interface IExternalDadataFIO {
  value: string;
  unrestrictedValue: string;
  data: IFIOObject;
}

type QC_TYPES = '0' | '1';
type FIO_PARTS = 'NAME' | 'PATRONYMIC' | 'SURNAME';
